// extracted by mini-css-extract-plugin
export default {"statistics_item":"dashboard_statistics_item__Mvs4-","progressDetails":"dashboard_progressDetails__wfKYf","heros":"dashboard_heros__2adDG"};